import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_star",
  "use": "svg_star-usage",
  "viewBox": "0 0 38 37",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 37\" id=\"svg_star\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m37.664 14.47-12.891-1.874L19 .904 13.23 12.596.339 14.47l9.325 9.097-2.206 12.846 11.543-6.069 11.532 6.069-2.195-12.846 9.326-9.097ZM19.001 26.767l-7.325 3.852 1.394-8.16-5.932-5.783 8.195-1.189L19 8.07l3.657 7.417 8.195 1.189-5.92 5.783 1.394 8.16-7.326-3.852Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol